import React from 'react'
import * as S from './Options.styled'
import { OptionsItem } from './OptionsItem/OptionsItem'
import type { OptionsProps } from './types'

export const Options = ({ children, borderless, gap = 0 }: OptionsProps) => {
  return (
    <S.Container data-testid="Options" $borderless={borderless} $gap={gap}>
      {children}
    </S.Container>
  )
}

Options.Item = OptionsItem
